import Checkbox from "@mui/material/Checkbox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import FormControlLabel from "@mui/material/FormControlLabel";
import "./style.scss";

export function CustomCheckbox({size = 20, label, checked, onChange }) {
  return (
    <label
      className="custom-checkbox"
      style={{ "--checkbox-size": `${size}px` }}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
      />

      <span className={`checkbox-box ${checked ? "checked" : ""}`}>
        {checked ? "✔" : ""}
      </span>

      {label}
    </label>
  );
}

export function IconCheckbox({ label, checked, onChange, fontWeight }) {
  return (
    <FormControlLabel
      style={{ '--icon-checkbox-font-weight': fontWeight }}
      className="custom-icon-checkbox"
      checked={checked}
      onChange={onChange}
      control={
        <Checkbox
          icon={<CheckBoxOutlineBlankIcon />}
          checkedIcon={<CheckBoxIcon />}
        />
      }
      label={label}
    />
  );
}
